var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91901 7.10112L3.43004 8.59009C2.87395 9.14618 2.55416 9.90282 2.56 10.698C2.56585 11.4932 2.87864 12.2545 3.46111 12.819C4.02557 13.4015 4.78699 13.7143 5.58207 13.7201C6.39529 13.7261 7.13402 13.4243 7.69014 12.8682L9.17911 11.3792M11.081 9.51374L12.57 8.02477C13.126 7.46868 13.4458 6.71204 13.44 5.91683C13.4341 5.12162 13.1214 4.36036 12.5389 3.79587C11.9746 3.23155 11.2133 2.91874 10.4181 2.9129C9.62285 2.90705 8.86611 3.20869 8.30999 3.76479L6.82102 5.25376M5.74207 10.5255L10.209 6.05863",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/IconLink.5cb4430dcea906ef81475b58fecff81a.svg";
export { ForwardRef as ReactComponent };